import { fixedUi } from '@/i18n/fixedUi';
import React from 'react';
import { useParams } from 'react-router-dom';
import TiktokPhase2OpsStubPage from '@/tiktok-platform/modules/ops/TiktokPhase2OpsStubPage';
import TiktokMarketingPageView from '@/tiktok-platform/modules/ops/TiktokMarketingPage';
import TiktokMarketingCouponsView from '@/tiktok-platform/modules/ops/TiktokMarketingCouponsPage';
import TiktokSampleQcPage from '@/tiktok-platform/modules/ops/TiktokSampleQcPage';
import { normalizeTiktokShopTypeSlug } from '@/tiktok-platform/constants/tiktokRoutes';

function useOpsTrack() {
  const { shopType } = useParams();
  return normalizeTiktokShopTypeSlug(shopType) || 'semi';
}

export function TiktokFullFulfillmentPage() {
  const track = useOpsTrack();
  return (
    <TiktokPhase2OpsStubPage
      track={track}
      title={fixedUi("备货发货")}
      moduleKey="fulfillment"
      listFnName="listFulfillment"
      syncFnName="syncFulfillment"
    />
  );
}

export function TiktokFullPrintPage() {
  const track = useOpsTrack();
  return (
    <TiktokPhase2OpsStubPage
      track={track}
      title={fixedUi("打印中心")}
      moduleKey="print"
      listFnName="listPrint"
      syncFnName="syncPrint"
      enablePrintAction
    />
  );
}

export function TiktokFullAftersalePage() {
  return <TiktokSampleQcPage />;
}

export function TiktokFullPackingPage() {
  const track = useOpsTrack();
  return (
    <TiktokPhase2OpsStubPage
      track={track}
      title={fixedUi("包装合规")}
      moduleKey="packing"
      listFnName="listPacking"
      syncFnName="syncPacking"
    />
  );
}

export function TiktokMarketingPage() {
  const track = useOpsTrack();
  return <TiktokMarketingPageView track={track} view="activities" />;
}

export function TiktokMarketingEnrollsPage() {
  const track = useOpsTrack();
  return <TiktokMarketingPageView track={track} view="enrolls" />;
}

/** @deprecated 活动商品已并入报名记录；保留路由兼容旧链接 */
export function TiktokMarketingProductsPage() {
  const track = useOpsTrack();
  return <TiktokMarketingPageView track={track} view="enrolls" />;
}

export function TiktokMarketingCouponsPage() {
  return <TiktokMarketingCouponsView />;
}

export function TiktokFullAdsPage() {
  const track = useOpsTrack();
  return (
    <TiktokPhase2OpsStubPage
      track={track}
      title={fixedUi("商品广告")}
      moduleKey="ads"
      listFnName="listAds"
      syncFnName="syncAds"
    />
  );
}

export function TiktokFullSalesPage() {
  const track = useOpsTrack();
  return (
    <TiktokPhase2OpsStubPage
      track={track}
      title={fixedUi("销量数据")}
      moduleKey="sales"
      listFnName="listSales"
      syncFnName="syncSales"
    />
  );
}
